export default __webpack_public_path__ + "static/media/DailyRoutine_07.f20093fb.png";